import React from "react";
import { t } from "../../../../../utils/i18n";

const Tags = ({ tags }) => (
  <>
    {tags !== "" && tags?.length > 0 && (
      <div>
        <div className="createtrade-badge-cont" title={t("p2p.create_trade.tags_tip")}>
          {tags?.map((tag, index) => (
            <p key={index} className="createtrade-badge mr-1">
              <i className="fas fa-tags"></i>{" "}
              {tag.label}
            </p>
          ))}
        </div>
      </div>
    )}
  </>
);

export default Tags;
